import { useUnauthedExperiment } from "../useExperiment/useUnauthedExperiment";
import { useFlippers } from "../useFlippers/useFlippers";

const QUALITY_STORY_SIGNUP_EXPERIMENT_NAME = "qualityStorySignup";

interface Options {
  /**
   * Emit the exposure event. Set this only where the variant UI actually differs, so the
   * experiment population is not diluted by visitors who never saw a difference.
   */
  shouldLog: boolean;
}

const useQualityStorySignupExperiment = ({ shouldLog }: Options) => {
  const [
    isQualityStorySignupEnabled,
    isDoraStorefrontsEnabled,
    isUhCustomExperienceEnabled,
    isAscensionCustomExperienceEnabled,
  ] = useFlippers(
    "platypus_quality_story_signup",
    "dora_storefronts",
    "vanguard_uh_custom_experience",
    "vanguard_ascension_custom_experience"
  );

  // Dora storefronts and the Vanguard custom experiences replace the standard signup funnel,
  // so visitors of those stores stay out of the experiment: legacy UI and no exposure event.
  const isEligible =
    isQualityStorySignupEnabled &&
    !isDoraStorefrontsEnabled &&
    !isUhCustomExperienceEnabled &&
    !isAscensionCustomExperienceEnabled;

  const group = useUnauthedExperiment({
    experiment: QUALITY_STORY_SIGNUP_EXPERIMENT_NAME,
    groups: ["control", "experiment"],
    shouldLog: isEligible && shouldLog,
    e2eGroup: "control",
  });

  return isEligible && group === "experiment";
};

export { QUALITY_STORY_SIGNUP_EXPERIMENT_NAME, useQualityStorySignupExperiment };
